module.exports = __webpack_public_path__ + "static/img/jining4.3ccc24ac.jpg";